import { render } from "./EditorJS.vue?vue&type=template&id=bfcd1174&scoped=true"
import script from "./EditorJS.vue?vue&type=script&lang=js"
export * from "./EditorJS.vue?vue&type=script&lang=js"

import "./EditorJS.vue?vue&type=style&index=0&id=bfcd1174&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfcd1174"]])

export default __exports__